import { ClaimDocumentAdapter } from '../../../adapter';

export default async function ClaimDocumentDeleteUseCase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/claim-document/delete'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/claim-document/delete'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-document/delete`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-document/delete`;
          
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/claim/claim-document/delete';

    const payload = {
        claimDocuments: [
            {
                id: event.id,
                txnClaimId: 1
            }
        ]
    };

    // handle request
    const result = await ClaimDocumentAdapter(endpoint, JSON.stringify(payload));

    return result;
}
